
        var result = require("!!../../../../../../node_modules/css-loader/index.js!./create-edit-org-modal.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/orgs/create-edit-org-modal/create-edit-org-modal.component.css
// module id = 741
// module chunks = 0